import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { KanbanPriorityProps } from '../types/interfaces'

interface UseKanbanPriorityOptions {
  props: KanbanPriorityProps
}

interface UseKanbanPriorityReturn {
  refPriorityLabel: ComputedRef<string | null>
}

export const useKanbanPriority = ({ props }: UseKanbanPriorityOptions): UseKanbanPriorityReturn => {
  const refPriorityLabel = computed<string | null>(() => {
    return Object.keys(props.kanbanPriority).find(
      key => props.kanbanPriority[key] === props.status,
    ) || null
  })

  return {
    refPriorityLabel,
  }
}
